import type { SVGProps } from 'react';

export const HandThumbsdownFillSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.3062 20.7281"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="20.7281" opacity="0" width="20.3062" x="0" y="0" />{' '}
        <path
          d="M19.9449 6.5537C19.9449 3.52245 18.0564 1.02675 15.5494 1.02675L13.85 1.02675C15.6201 2.37284 16.447 4.37499 16.4062 6.65663C16.3769 9.11209 15.4929 10.8953 14.5642 12.1117L15.9178 12.1117C18.1939 12.1117 19.9449 9.68006 19.9449 6.5537ZM15.0115 6.62733C15.0719 2.90292 12.0459 0.123238 7.37128 0.0841755L6.01952 0.0744098C4.73593 0.0646442 3.758 0.1623 3.1955 0.310543C2.34765 0.515425 1.60117 1.04296 1.60117 2.00761C1.60117 2.37694 1.69531 2.66542 1.81074 2.87753C1.88183 2.98769 1.86855 3.08105 1.75918 3.12636C1.1248 3.41444 0.631054 4.01522 0.631054 4.791C0.631054 5.24374 0.756249 5.6369 0.979101 5.92967C1.07246 6.06034 1.05117 6.17499 0.901757 6.26835C0.444726 6.55038 0.128711 7.12362 0.128711 7.78475C0.128711 8.26659 0.278711 8.75565 0.532617 9.01112C0.675782 9.13201 0.651758 9.22264 0.506836 9.34979C0.191797 9.62303 0 10.0924 0 10.6596C0 11.6709 0.790427 12.4916 1.8205 12.4916L5.34765 12.4916C6.20097 12.4916 6.75429 12.925 6.75429 13.6142C6.75429 14.9271 5.08398 17.3847 5.08398 19.1703C5.08398 20.1427 5.70585 20.7281 6.54765 20.7281C7.27265 20.7281 7.65311 20.2513 8.06639 19.4433C9.55487 16.5595 11.5289 14.2164 13.0457 12.2008C14.3572 10.4615 14.9742 8.97596 15.0115 6.62733Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
